import type { SvgPathProps } from '../Icon';

import { getIcon } from '../Icon/utils';

const LocationFill: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.99 6.131c-1.575-.278-5.94-.774-10.003 1.863-4.13 2.68-5.759 6.221-6.402 9.03-.997 4.356.573 8.27 2.701 12.076 1.935 3.46 4.964 7.925 10.634 14.517l.491.57.493-.568c1.193-1.377 3.822-4.53 5.442-6.706 2.023-2.718 4.336-6.162 6.037-9.518 1.303-2.572 2.474-5.968 2.03-9.061-.464-3.229-1.985-6.562-4.715-8.95-2.42-2.118-5.103-2.968-6.709-3.253Zm3.023 13.436a5.633 5.633 0 1 1-11.266 0 5.633 5.633 0 0 1 11.265 0Z"
    />
  );

  const normalHover = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.639 6.067c4.07-2.79 8.774-2.202 10.022-1.969 1.602.3 4.356 1.185 6.835 3.335 2.796 2.426 4.542 6.224 4.776 9.607.208 2.995-1.176 6.747-2.465 9.433-1.3 2.707-3.879 7.135-5.911 10.017a582.7 582.7 0 0 0-1.02 1.452l-.001.003c-1.488 2.122-3.267 4.662-4.238 5.845l-.529.645-.496-.671c-5.301-7.175-8.57-12.385-10.497-16.025-2.127-4.015-3.572-8.163-2.89-12 .671-3.775 2.305-6.857 6.414-9.672Zm7.496 17.157a5.675 5.675 0 1 0 0-11.35 5.675 5.675 0 0 0 0 11.35Z"
    />
  );

  const xSmall = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.403 7.569c4.107-2.666 8.517-2.163 10.102-1.883 1.623.288 4.332 1.147 6.776 3.285 2.759 2.414 4.293 5.779 4.761 9.035.451 3.136-.736 6.564-2.043 9.144-1.706 3.366-4.024 6.818-6.05 9.539-1.623 2.18-4.254 5.336-5.448 6.713l-.599.691-.596-.693c-5.675-6.597-8.71-11.07-10.65-14.54-2.132-3.812-3.724-7.766-2.715-12.174.649-2.837 2.295-6.412 6.462-9.117Zm7.537 16.954c2.903 0 5.201-2.549 5.201-5.299 0-2.75-2.298-5.228-5.2-5.228-3.197 0-5.327 2.566-5.327 5.316 0 2.852 2.424 5.21 5.326 5.21Z"
    />
  );

  const xSmallHover = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.386 6.212c4.118-2.821 8.868-2.225 10.126-1.99 1.62.303 4.4 1.195 6.902 3.367 2.825 2.45 4.587 6.284 4.824 9.702.21 3.034-1.189 6.814-2.48 9.502-1.303 2.715-3.886 7.15-5.922 10.037l-1.019 1.452c-1.487 2.123-3.271 4.67-4.246 5.857l-.643.783-.602-.815c-5.304-7.178-8.576-12.394-10.508-16.042-2.13-4.02-3.595-8.205-2.904-12.09.677-3.81 2.33-6.925 6.472-9.763Zm7.574 16.925a5.328 5.328 0 1 0 0-10.656 5.328 5.328 0 0 0 0 10.656Z"
    />
  );

  return getIcon({ size, isHovered, normal, normalHover, xSmall, xSmallHover });
};

export default LocationFill;
